export default __webpack_public_path__ + "static/media/error-kenji.0614c602.png";